import { alpha } from '@mui/material';

export const defaultInputStyles = {
  cursor: 'text',
  padding: '4px 16px',
  border: 'none',
  background: 'transparent',
  width: '100%',
  height: '100%',
  fontWeight: 'normal',
};

export const defaultSxStyles = {
  '& .MuiInputBase-root': {
    height: '100%',
    '&:before, &:after': { display: 'none' },
    '&.Mui-disabled': {
      backgroundColor: (theme) => alpha(theme?.palette?.primary?.main, 0.04),
      cursor: 'not-allowed',
    },
  },
};
